import { render, staticRenderFns } from "./cow-medical-info.vue?vue&type=template&id=0f231b82&scoped=true&"
import script from "./cow-medical-info.vue?vue&type=script&lang=js&"
export * from "./cow-medical-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f231b82",
  null
  
)

export default component.exports